/** Aufträge und Sendungen (Paket 1). */
import type { KlaerfallGrund, SendungStatus } from '@storeos/contracts';
import { api, post } from '../api';
import { liste, qs } from './http';
import type { AdressKorrekturErgebnis, AuftragFilter, AuftragZeile, OrderDetail, TimelineEintrag } from './typen';

export const auftraege = (f: AuftragFilter) => liste<AuftragZeile>(`/auftraege${qs(f)}`);
export const auftrag = (id: string) => api<OrderDetail>(`/auftraege/${id}`);
export const auftragTimeline = (id: string) => liste<TimelineEintrag>(`/auftraege/${id}/timeline`);

export interface AdressKorrektur {
  typ: 'rechnung' | 'lieferung';
  version: number;
  grund?: string;
  vorname?: string; nachname: string; firma?: string | null; strasse: string; hausnummer: string; zusatz?: string | null; plz: string; ort: string; land: string;
}
/** 409 bei Versionskonflikt; Antwort enthält Hinweise (z. B. Label mit alter Adresse). */
export const adresseKorrigieren = (id: string, a: AdressKorrektur) => post<AdressKorrekturErgebnis>(`/auftraege/${id}/adresse`, a);

export const sendungStatus = (id: string, nach: SendungStatus, grund?: string) => post<unknown>(`/sendungen/${id}/status`, { nach, grund });
export const klaerfallMelden = (id: string, grund: KlaerfallGrund, text: string) => post<unknown>(`/sendungen/${id}/klaerfall`, { grund, text });
/** `grund` = was geklärt wurde (Pflicht, landet im Audit). */
export const klaerfallLoesen = (id: string, grund: string) => post<unknown>(`/sendungen/${id}/klaerfall/loesen`, { grund });
export const partnerTracking = (id: string, carrier: string, tracking: string) =>
  post<{ sendung_id: string }>(`/sendungen/${id}/partner-tracking`, { carrier, tracking });
